export default __webpack_public_path__ + "static/media/Pos8.db5b3696.svg";